/* Floodlight · hero football, draw routine (owner: home). Port of prototype 24-ball-draw.js.
   Defines SS._ballDraw(B, now) -> true while the loop should keep running. Loaded before ss-ball-geo.js. */
(function () {
  'use strict';
  if (window.SS_LOADED_ballDraw) return;
  window.SS_LOADED_ballDraw = true;
  var SS = window.SS = window.SS || {};

  SS._ballDraw = function (B, now) {
    if (!B || !B.ctx) return false;
    var cv = B.cv, ctx = B.ctx;
    var w = cv.clientWidth, h = cv.clientHeight;
    if (!w || !h) return true;
    var reduce = B.reduced();
    var narrow = (window.innerWidth || 1440) < 768;
    var dpr = Math.min(narrow ? 1.5 : 2, window.devicePixelRatio || 1);
    var W = Math.round(w * dpr), H = Math.round(h * dpr);
    if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; B.pat = null; }
    var dt = Math.max(0, Math.min(0.05, (now - B.last) / 1000));
    B.last = now;
    var idle = narrow && !B.drag && now - B.act > 5000 && now - B.t0 > 3800;
    if (!B.drag && !reduce) {
      var decay = Math.exp(-dt * (idle ? 1.3 : 1.5));
      B.wy = B.wy * decay + (idle ? 0 : 0.46) * (1 - decay);
      B.wx = B.wx * decay + (idle ? 0 : 0.12) * (1 - decay);
      B.rot(B.wy * dt, B.wx * dt);
    }
    var ease = Math.min(1, dt * 4);
    B.tx += (B.hx - B.tx) * ease;
    B.ty += (B.hy - B.ty) * ease;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, w, h);
    var t = (now - B.t0) / 1000 - 0.55;
    if (t < 0) return true;
    var R = Math.min(w, h) * 0.34;
    var base = h * 0.46;
    var lift = 0, energy = 0;
    var ht = (now - B.hop) / 1000;
    if (!reduce) {
      if (t < 2.6) { lift = Math.abs(Math.cos(t * 5.4)) * Math.exp(-t * 2.9) * R * 2.1; energy = Math.exp(-t * 2.4); }
      lift += (1 - Math.cos(Math.min(1, Math.max(0, t - 1.4)) * Math.PI)) * 0.5 * R * 0.05 * (1 + Math.sin(now * 0.0017));
      if (ht >= 0 && ht < 1.6) { lift += Math.abs(Math.sin(ht * 5.2)) * Math.exp(-ht * 3.1) * R * 1.25; energy = Math.max(energy, Math.exp(-ht * 2.6)); }
    }
    var cx = w / 2 + B.tx * R * 0.14, cy = base - lift + B.ty * R * 0.08;
    var gy = base + R * 1.04;
    var sh = 1 - Math.min(1, lift / (R * 2.2));
    var contact = Math.max(0, 1 - lift / (R * 0.1)) * energy;
    var alpha = Math.min(1, t / 0.12);
    ctx.globalAlpha = alpha;

    /* light pool, kick ring and ground shadow */
    var pool = ctx.createRadialGradient(w / 2, gy, 0, w / 2, gy, R * 1.9);
    pool.addColorStop(0, 'rgba(226,236,255,.22)');
    pool.addColorStop(1, 'rgba(214,230,255,0)');
    ctx.save();
    ctx.translate(w / 2, gy); ctx.scale(1, 0.26); ctx.translate(-w / 2, -gy);
    ctx.fillStyle = pool; ctx.beginPath(); ctx.arc(w / 2, gy, R * 1.9, 0, Math.PI * 2); ctx.fill();
    var fl = (now - B.flash) / 1000;
    if (fl >= 0 && fl < 0.7) {
      ctx.strokeStyle = 'rgba(234,242,255,' + ((1 - fl / 0.7) * 0.55).toFixed(3) + ')';
      ctx.lineWidth = 3;
      ctx.beginPath(); ctx.arc(w / 2, gy, R * (0.5 + fl * 2.6), 0, Math.PI * 2); ctx.stroke();
    }
    var sg = ctx.createRadialGradient(w / 2, gy, 0, w / 2, gy, R);
    sg.addColorStop(0, 'rgba(0,4,10,' + (0.72 * sh).toFixed(3) + ')');
    sg.addColorStop(0.6, 'rgba(0,4,10,' + (0.3 * sh).toFixed(3) + ')');
    sg.addColorStop(1, 'rgba(0,4,10,0)');
    ctx.translate(w / 2, gy); ctx.scale((0.42 + 0.58 * sh) * (1 + contact * 0.12), 1); ctx.translate(-w / 2, -gy);
    ctx.fillStyle = sg; ctx.beginPath(); ctx.arc(w / 2, gy, R, 0, Math.PI * 2); ctx.fill();
    ctx.restore();

    /* the ball */
    ctx.save();
    if (contact > 0.01) {
      var q = contact * 0.08;
      ctx.translate(cx, cy + R); ctx.scale(1 + q, 1 - q); ctx.translate(-cx, -(cy + R));
    }
    var g = ctx.createRadialGradient(cx - R * 0.38, cy - R * 0.44, R * 0.05, cx - R * 0.1, cy - R * 0.1, R * 1.15);
    g.addColorStop(0, '#FFFDF7'); g.addColorStop(0.36, '#F2EEE6'); g.addColorStop(0.76, '#B9C1CE'); g.addColorStop(1, '#5A6780');
    ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.fillStyle = g; ctx.fill(); ctx.clip();
    var M = B.M;
    var P = function (p) { return [M[0] * p[0] + M[1] * p[1] + M[2] * p[2], M[3] * p[0] + M[4] * p[1] + M[5] * p[2], M[6] * p[0] + M[7] * p[1] + M[8] * p[2]]; };
    var scr = function (v) {
      var x = v[0], y = v[1];
      if (v[2] < 0) { var l = Math.hypot(x, y) || 1; x /= l; y /= l; }
      return [cx + x * R, cy - y * R];
    };
    var path = function (pts) {
      for (var k = 0; k < pts.length; k++) { var s = scr(pts[k]); if (k) ctx.lineTo(s[0], s[1]); else ctx.moveTo(s[0], s[1]); }
    };
    ctx.lineJoin = 'round'; ctx.lineCap = 'round';
    ctx.lineWidth = Math.max(1, R * 0.012);
    ctx.strokeStyle = 'rgba(46,54,72,.45)';
    ctx.beginPath();
    B.geo.seams.forEach(function (seam) {
      var pts = seam.map(P);
      if (pts[0][2] < 0 && pts[pts.length - 1][2] < 0) return;
      path(pts);
    });
    ctx.stroke();
    var L = [-0.5, 0.62, 0.6];
    B.geo.pents.forEach(function (pe, i) {
      var pts = pe.ring.map(P);
      if (pts.every(function (v) { return v[2] < 0; })) return;
      var n = P(pe.n);
      var lit = Math.max(0, n[0] * L[0] + n[1] * L[1] + n[2] * L[2]);
      ctx.beginPath();
      path(pts);
      ctx.closePath();
      ctx.fillStyle = i === 7
        ? 'rgb(' + ((150 + 105 * lit) | 0) + ',' + ((80 + 78 * lit) | 0) + ',' + ((8 + 22 * lit) | 0) + ')'
        : 'rgb(' + ((13 + 36 * lit) | 0) + ',' + ((23 + 42 * lit) | 0) + ',' + ((42 + 52 * lit) | 0) + ')';
      ctx.fill();
      ctx.strokeStyle = 'rgba(6,12,24,.55)';
      ctx.stroke();
    });
    ctx.lineWidth = Math.max(0.8, R * 0.007);
    ctx.strokeStyle = 'rgba(120,112,100,.24)';
    ctx.beginPath();
    B.geo.scuffs.forEach(function (sc) {
      var a = P(sc[0]), b = P(sc[1]);
      if (a[2] < 0.2) return;
      var s1 = scr(a), s2 = scr(b);
      ctx.moveTo(s1[0], s1[1]); ctx.lineTo(s2[0], s2[1]);
    });
    ctx.stroke();
    var sd = ctx.createRadialGradient(cx - R * 0.42, cy - R * 0.5, R * 0.2, cx - R * 0.2, cy - R * 0.2, R * 1.55);
    sd.addColorStop(0, 'rgba(255,255,255,0)'); sd.addColorStop(0.55, 'rgba(6,12,24,.06)'); sd.addColorStop(0.85, 'rgba(6,12,24,.45)'); sd.addColorStop(1, 'rgba(3,6,14,.8)');
    ctx.fillStyle = sd; ctx.fillRect(cx - R, cy - R, R * 2, R * 2);
    var sp = ctx.createRadialGradient(cx - R * 0.36, cy - R * 0.44, 0, cx - R * 0.36, cy - R * 0.44, R * 0.6);
    sp.addColorStop(0, 'rgba(255,250,238,.66)'); sp.addColorStop(0.4, 'rgba(255,246,230,.16)'); sp.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = sp; ctx.fillRect(cx - R, cy - R, R * 2, R * 2);
    var gl = ctx.createLinearGradient(0, cy + R * 0.3, 0, cy + R);
    gl.addColorStop(0, 'rgba(46,150,96,0)'); gl.addColorStop(1, 'rgba(46,150,96,.32)');
    ctx.fillStyle = gl; ctx.fillRect(cx - R, cy - R, R * 2, R * 2);
    if (B.grain) {
      if (!B.pat) B.pat = ctx.createPattern(B.grain, 'repeat');
      if (B.pat) { ctx.globalAlpha = alpha * 0.32; ctx.fillStyle = B.pat; ctx.fillRect(cx - R, cy - R, R * 2, R * 2); ctx.globalAlpha = alpha; }
    }
    var rg = ctx.createLinearGradient(cx, cy - R * 0.3, cx + R, cy + R * 0.1);
    rg.addColorStop(0, 'rgba(170,205,255,0)'); rg.addColorStop(1, 'rgba(196,220,255,.62)');
    ctx.lineWidth = R * 0.08; ctx.strokeStyle = rg;
    ctx.beginPath(); ctx.arc(cx, cy, R, -1.0, 1.0); ctx.stroke();
    ctx.restore();

    /* kick dust */
    if (B.dust.length) {
      for (var i = B.dust.length - 1; i >= 0; i--) {
        var d = B.dust[i];
        d.life += dt;
        if (d.life > d.max) { B.dust.splice(i, 1); continue; }
        d.vy += 320 * dt; d.x += d.vx * dt; d.y += d.vy * dt;
        if (d.y > gy + 4) { d.y = gy + 4; d.vy *= -0.3; d.vx *= 0.6; }
        var da = 1 - d.life / d.max;
        ctx.fillStyle = d.g ? 'rgba(92,196,128,' + (da * 0.85).toFixed(3) + ')' : 'rgba(236,243,255,' + (da * 0.9).toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(d.x, d.y, d.s, 0, Math.PI * 2); ctx.fill();
        if (!d.g) { ctx.fillStyle = 'rgba(214,230,255,' + (da * 0.14).toFixed(3) + ')'; ctx.beginPath(); ctx.arc(d.x, d.y, d.s * 3.2, 0, Math.PI * 2); ctx.fill(); }
      }
    }
    ctx.globalAlpha = 1;
    var settled = idle && Math.abs(B.wy) < 0.004 && Math.abs(B.wx) < 0.004 && !B.dust.length && ht > 1.7 && t > 3;
    return !settled;
  };
})();
